// Paleta de colores principal usada en la aplicación
export const Colors = {
  primary: "#43C251", // Color principal
  primarySoft: "#eef3ff", // Variante suave del color principal (fondo, badges, etc.)

  textPrimary: "#0d0c61", // Color principal para textos (títulos, encabezados)
  textSecondary: "#4e5774", // Color para textos secundarios o descripciones

  borderInputs: "#D1D5DB", // Color para bordes de inputs o elementos interactivos
  textPlaceholder: "#9CA3AF", // Color para textos de placeholder dentro de inputs

  badgeGray: "#F4F4F5", // Color de fondo para badges o etiquetas grises
};